import BaseModel from '../core/BaseModel'
//import CategoriesModel from './CategoriesModel'
export default class ServicePackFromProductModel extends BaseModel {
    constructor() {
        super({ 
                name: "service_pack_from_product",
                tableName: 'core_service_pack'
            }, 
            {
            id: { 
                name: 'id', 
                type: "String", 
                label: 'ID', 
                primaryKey: true,
                display: false
            },
            code: {
                name: 'code',
                type: "String", 
                label:'Mã gói dịch vụ',
                width: 12,
                sortable: false,
                filter: { type: 'input', match: 'custom', placeHolder: 'Nhập mã gói dịch vụ'}
            },
            name: { 
                name: 'name', 
                type: "String", 
                label: 'Tên gói dịch vụ',
                width: 18,
                sortable: false,
                filter: { type: 'input',  match: 'custom', placeHolder: 'Nhập tên gói dịch vụ'}
            },
            description: {
                name: 'description',
                type: "String",
                label: 'Mô tả',
                width: 18,
                sortable: false,
                filter: { type: 'input',  match: 'custom', placeHolder: 'Nhập mô tả lỗi'}
            }
        },)
    }

}